import { useState, useEffect } from "react"
import { validations } from "../form"
import { useUserProvider } from "../../providers/UserProvider"
import OnboardingContent from "../../components/onboarding/OnboardingContent"

const DEFAULT_VALUES = {
  isEdit: false,
  qrcode: "",
  qrcode_file: "",
  play_store_link: "",
  app_store_link: "",
  media_metadata: {},
  privacy_policy_url: "",
}

const OnboardingFinalInfo = ({ handleSubmit, initialValues }) => {
  const { user, setUser } = useUserProvider();

  const [fields, setFields] = useState([
    {
      component: "qrcode",
      name: "qrcode",
      label: "QR Code",
      placeholder: "",
      isFieldRow: true,
      required: false,
    },
    {
      component: "play_store_link",
      field: "text",
      name: "play_store_link",
      label: "Google Play Link",
      placeholder: "",
      isFieldRow: true,
      required: false,
    },
    {
      component: "app_store_link",
      field: "text",
      name: "app_store_link",
      label: "Apple Link",
      placeholder: "",
      isFieldRow: true,
      required: false,
    },
  ]);

  useEffect(() => {
    if (!user.app_data?.about?.store?.privacy_policy) {
      console.error('Privacy policy is missing or undefined');
      return;
    }
    let updatedFields = [...fields];

    const privacyPolicyCondition = "Use my app’s 'Companion Website' (default)";

    if (user.app_data.about.store.privacy_policy === privacyPolicyCondition) {
      if (!updatedFields.some(field => field.name === "privacy_policy_url")) {
        updatedFields = [
          ...updatedFields,
          {
            component: "privacy_policy_url",
            field: "text",
            name: "privacy_policy_url",
            label: "Privacy Policy Link",
            placeholder: "Enter the privacy policy URL",
            isFieldRow: true,
            required: false,
          }
        ];
      }
    } else {
      updatedFields = updatedFields.filter(field => field.name !== "privacy_policy_url");
    }

    setFields(updatedFields);
  }, [user]);

  const schema = {
    qrcode: validations.str_255,
    play_store_link: validations.str_255,
    app_store_link: validations.str_255,
    privacy_policy_url: validations.str_255,
  };

  const handleFormatPayload = (values) => {
    const { isEdit, privacy_policy_url, ...rest } = values

    const newPayload = {
      onboarding: {
        ...rest
      },
      about: {
        privacy_policy_url
      }
    }

    return newPayload
  }

  // reformat data if components used vs payload data is different
  // if you didnt change payload response, skip this and just pass values to defaultValues props
  const formatDefaultValues = () => {
    if (initialValues?.app?.id) {
      const newPayload = {
        ...DEFAULT_VALUES,
        qrcode: initialValues?.onboarding?.qrcode,
        qrcode_file: initialValues?.onboarding?.qrcode_file,
        play_store_link: initialValues?.onboarding?.play_store_link,
        app_store_link: initialValues?.onboarding?.app_store_link,
        media_metadata: initialValues?.onboarding?.media_metadata,
        privacy_policy_url: initialValues?.app_data?.about?.privacy_policy_url
      }

      return newPayload
    }

    return DEFAULT_VALUES
  }

  return {
    config: {
      label: "Onboarding - Final Info",
      resourceEndpoint: "apps",
      columnsMetadata: [
        { customComponent: (
          <OnboardingContent
            title="Final Info"
            defaultValues={formatDefaultValues()}
            schema={schema}
            fields={fields}
            handleSubmit={handleSubmit}
            handleFormatPayload={handleFormatPayload}
            successCallbackFn={(res) => {  
              const selectedApp = {
                id: res.data.id,
                name: res.data.name,
                lite: res.data.setup.premium_lite,
                plus: res.data.setup.premium_plus,
                isPending: res.data.is_pending,
                initials: res.data.name
                  .split(" ")
                  .map((n) => n[0])
                  .join(""),
              }

              setUser({
                ...user,
                app: selectedApp,
                app_data: {
                  ...user.app_data,
                  about: {
                    ...user.app_data.about,
                    privacy_policy_url: res?.data?.about?.privacy_policy_url
                  }
                }
              });
            }}
          />
        ) },
      ],
    }
  }
}

export default OnboardingFinalInfo;